import HttpService from "./HttpService";

let usuarioService = {
    trocarSenha: (body) => {
        return HttpService.backApi.post("/usuario/trocar-senha", body);
    },

    trocarSenhaTerceiro: (body) => {
        return HttpService.backApi.put("/usuario/trocar-senha-terceiro", body);
    },

    updateUsuario: (body) => {
        return HttpService.backApi.post("/usuario/update", body);
    },

    buscarDados: () => {
        return HttpService.backApi.get("/usuario/dados");
    },

    listaDeAcessos: () => {
        return HttpService.backApi.get("/usuario/acessos")
    },

    buscarUsuarios: (itensPorPagina, pagina, search) => {
        return HttpService.backApi.get(`/usuario/paginado?size=${itensPorPagina}&page=${pagina}&search=${search}`);
    },
};

export default usuarioService;
